import styled from "@emotion/styled";
import { Typography } from "@kaltura/ds-react-components";
import { alpha, Box } from "@kaltura/mediaspace-shared-styled";
import { StyledIllustration } from "@kaltura/mediaspace-shared-ui";

export const StyledDragAndDropIllustration = (
    <StyledIllustration
        fileName={"Upload.svg"}
        xmlns="http://www.w3.org/2000/svg"
        width="301"
        height="300"
        fill="none"
        viewBox="0 0 301 300"
    >
        <g>
            <g className="Tone1">
                <path
                    fill="#333"
                    d="M98.836 67.818H133.5v1H98.836a7.5 7.5 0 0 0-7.5 7.5v86.979l1.106 12.969a.506.506 0 0 1 .033.389l2.899 33.982a7.5 7.5 0 0 0 7.473 6.863h155.351c5.283 0 8.91-5.317 6.983-10.236L248 163.413V76.318a7.5 7.5 0 0 0-7.5-7.5h-52v-1h52a8.5 8.5 0 0 1 8.5 8.5v86.906l17.112 43.675c2.184 5.575-1.927 11.601-7.914 11.601H102.847a8.5 8.5 0 0 1-8.47-7.778l-2.867-33.621c-4.697.889-8.214 1.643-12.847 3.133-5.875 1.89-11.631 4.374-16.215 8.402-4.584 4.027-7.874 9.785-7.827 15.818.052 6.791 4.334 13.086 9.959 17.036 5.626 3.952 12.437 5.871 19.263 7.233 13.01 2.594 26.272 3.361 39.565 4.13 3.484.202 6.971.403 10.455.638 16.755 1.128 33.759 3.09 49.423 9.366 15.667 6.277 30.063 17.371 37.217 32.786a.5.5 0 1 1-.907.421c-7.017-15.119-21.175-26.066-36.682-32.279-15.51-6.214-32.38-8.17-49.118-9.296-3.461-.234-6.93-.434-10.403-.635h-.007c-13.302-.769-26.654-1.541-39.739-4.151-6.858-1.368-13.839-3.319-19.642-7.395-5.804-4.076-10.328-10.641-10.384-17.846-.05-6.399 3.429-12.415 8.167-16.577 4.737-4.162 10.646-6.697 16.569-8.603 4.723-1.519 8.304-2.283 13.067-3.182l-1.088-12.76V76.318a8.5 8.5 0 0 1 8.5-8.5Z"
                />
                <path
                    fill="#333"
                    d="M107.5 76h26v25a8 8 0 0 0 8 8H166v14.5h-15.5a7.5 7.5 0 0 0-7.5 7.5v12a7.5 7.5 0 0 0 7.5 7.5h17a7.5 7.5 0 0 0 7.5-7.5v-9.5h22.5a7.5 7.5 0 0 0 7.5-7.5v-24a7.5 7.5 0 0 0-7.5-7.5h-9V76h43a8.5 8.5 0 0 1 8.5 8.5v68a8.5 8.5 0 0 1-8.5 8.5h-124a8.5 8.5 0 0 1-8.5-8.5v-68a8.5 8.5 0 0 1 8.5-8.5Z"
                />
                <path
                    fill="#333"
                    fillRule="evenodd"
                    d="M132.384 173.09a4.5 4.5 0 0 0-4.474 4.981l1.723 16a4.5 4.5 0 0 0 4.474 4.019h86.992c2.895 0 5.037-2.695 4.384-5.515l-3.705-16a4.498 4.498 0 0 0-4.384-3.485h-85.01Zm-3.48 4.874a3.5 3.5 0 0 1 3.48-3.874h85.01a3.5 3.5 0 0 1 3.41 2.71l3.704 16a3.5 3.5 0 0 1-3.409 4.29h-86.992a3.5 3.5 0 0 1-3.48-3.126l-1.723-16Z"
                    clipRule="evenodd"
                />
                <path
                    fill="#333"
                    d="m154.202 135.518-.024.005c-2.189.544-3.789 2.066-5.32 3.633a.5.5 0 0 1-.715-.699c1.52-1.556 3.298-3.284 5.794-3.904a1.57 1.57 0 0 1 .4-.053.856.856 0 0 1 .561.2.832.832 0 0 1 .254.463l.001.004c.047.212.068.423.073.631.008.401-.046.786-.098 1.133l-.014.097c-.056.369-.105.694-.108 1.005.264-.127.522-.271.796-.424l.104-.057a9.34 9.34 0 0 1 1.268-.617c.375-.141.797-.24 1.222-.271.114-.008.229-.012.342-.01.535.009 1.097.138 1.551.479.032.024.062.049.092.074.218.184.381.395.51.562l.028.037c.163.21.282.353.436.458.273.185.703.264 1.167.227.429-.033.843-.148 1.309-.277l.117-.032c2.087-.577 4.487-1.009 6.69-.377a.5.5 0 0 1-.276.961c-1.922-.551-4.093-.188-6.148.379l-.128.036c-.45.125-.956.266-1.486.307-.582.046-1.272-.034-1.806-.397-.302-.205-.508-.47-.665-.672l-.001-.002c-.169-.218-.286-.368-.44-.484-.233-.176-.566-.272-.966-.279a3.353 3.353 0 0 0-1.196.217c-.386.145-.747.339-1.134.555l-.108.059-.001.001a11.75 11.75 0 0 1-1.122.574 1.207 1.207 0 0 1-.316.091.738.738 0 0 1-.522-.118.72.72 0 0 1-.29-.518l-.001-.006c-.07-.562.015-1.123.089-1.603l.018-.124c.072-.478.12-.883.063-1.264Z"
                />
                <path
                    fill="#333"
                    fillRule="evenodd"
                    d="M48 146s-.789-1.092-1.9-3.071l.015.052.005.019s-7.907-1.553-11.98-8.182c-2.51-4.087-3.86-9.536-4.048-16.347-.016-.555-.016-1.612 1.49-.668 3.628 2.276 6.623 6.553 8.931 10.946-1.598-6.512-2.274-14.43-.251-22.973.246-.776.565-1.155 1.304-.246C47.96 113.393 51 122.518 51 132.378c0 0 2.686-16.507 14.817-23.889.73-.444 2.366-1.324 2.366 1.014 0 9.666-2.237 17.33-6.644 23.37 3.414-2.053 8.05-3.727 14.8-3.956.52-.017 1.712-.017.547 1.184-6.97 7.185-14.118 12.722-22.692 16.058 0 0-1.979-1.806-1.678-4.174C46.73 147.27 48 146 48 146Zm14.784-28.597a.5.5 0 0 1-.053.705c-1.516 1.302-2.783 2.93-3.772 4.707-1.507 2.707-2.287 5.241-2.994 8.853a39.411 39.411 0 0 0-.253 1.47l-.02.123-.007.043a.501.501 0 0 1-.988-.153l.007-.046.02-.124a55.728 55.728 0 0 1 .26-1.505c.718-3.671 1.525-6.316 3.102-9.148 1.038-1.864 2.376-3.589 3.993-4.978a.5.5 0 0 1 .705.053Zm-28.258 7.964a.5.5 0 0 1 .625.33c1.642 5.315 4.169 9.023 7.541 11.201a.5.5 0 0 1-.542.84c-3.63-2.345-6.268-6.286-7.954-11.746a.5.5 0 0 1 .33-.625Z"
                    clipRule="evenodd"
                />
            </g>
            <g className="Primary">
                <path
                    fill="#006EFA"
                    fillRule="evenodd"
                    d="M141.5 47a8 8 0 0 0-8 8v46a8 8 0 0 0 8 8h39a8 8 0 0 0 8-8V55a8 8 0 0 0-8-8h-39Zm19.34 11.501.016.001h.013l.011-.002h.022c.135 0 .265.054.36.151l14.596 15a.5.5 0 1 1-.716.698l-13.834-14.216V97a.5.5 0 0 1-1 0V60.342l-13.447 14.004a.5.5 0 0 1-.722-.692l14.183-14.77a.5.5 0 0 1 .518-.383Z"
                    clipRule="evenodd"
                />
                <path
                    fill="#006EFA"
                    d="m92.695 191 1.682 19.722a8.5 8.5 0 0 0 8.47 7.778H224.5V236a8 8 0 0 1-8 8h-30.496a87.86 87.86 0 0 0-2.718-1.143c-15.664-6.276-32.668-8.238-49.423-9.366-3.485-.235-6.971-.436-10.455-.638-13.293-.769-26.556-1.536-39.565-4.13-6.826-1.362-13.637-3.281-19.263-7.233-5.625-3.95-9.907-10.245-9.96-17.036-.038-4.934 2.156-9.684 5.464-13.454h32.611Z"
                />
                <path
                    fill="#006EFA"
                    d="M43.5 191h15.273c-3.125 3.807-5.19 8.521-5.152 13.462.055 7.205 4.58 13.77 10.384 17.846 5.803 4.076 12.784 6.027 19.642 7.395 13.085 2.61 26.437 3.382 39.739 4.151h.007c3.473.201 6.942.401 10.403.635 16.737 1.126 33.608 3.082 49.118 9.296l.531.215H43.5a8 8 0 0 1-8-8v-37a8 8 0 0 1 8-8Zm-5-50a8.002 8.002 0 0 0-7.938 7h40.876a8.002 8.002 0 0 0-7.938-7h-25Zm33 8h-41v6h41v-6Zm0 7h-41v6h41v-6Zm0 7a8 8 0 0 1-8 8h-25a8 8 0 0 1-8-8h41Z"
                />
            </g>
        </g>
    </StyledIllustration>
);

export const StyledHiddenInput = styled("input")({
    visibility: "hidden",
    display: "none",
});

export const StyledText = styled(Typography)(({ theme }) => ({
    marginTop: theme.typography.pxToRem(8),
    marginBottom: theme.typography.pxToRem(16),
    maxWidth: "100%",
}));

export const StyledBox = styled(
    Box,
    {
        shouldForwardProp: (prop) => {
            return !["withColor", "fullSize"].includes(prop.toString());
        },
    }
)<{ withColor: boolean; fullSize: boolean }>(({ theme, withColor, fullSize }) => ({
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",

    height: theme.typography.pxToRem(200),
    [theme.breakpoints.down("sm")]: {
        height: "unset",
    },
    padding: theme.typography.pxToRem(40),
    paddingTop: theme.typography.pxToRem(32),
    marginBottom: theme.typography.pxToRem(16),

    ...(
        fullSize && {
            height: "unset",
            padding: theme.typography.pxToRem(80),
            paddingTop: theme.typography.pxToRem(80), // override the non-fullsize rule
            marginBottom: theme.typography.pxToRem(60),
        }
    ),

    borderRadius: theme.kaltura.shape.roundness1,
    borderColor: theme.kaltura.palette.tone4,
    ...(
        withColor && {
            backgroundColor: alpha(theme.kaltura.palette.primary.main, 0.08),
            borderColor: theme.kaltura.palette.primary.main,
        }
    ),

    borderStyle: "dashed",
    borderWidth: 2,
    cursor: "grab",
    [`&:active`]: {
        cursor: "grabbing",
    },
}));
